module.exports = __webpack_public_path__ + "06_long_brown.9cbdc57f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/06_long_brown.png
// module id = 5pVm
// module chunks = 0